import { connect } from 'react-redux';
import { bindActionCreators } from 'redux';
import get from 'lodash/get';
import * as LoaderAction from 'yoda-site-components/lib/actions/LoadingAction';
import * as addToCartActions from 'yoda-site-components/lib/actions/AddToCartAction';
import * as siteAccountAction from 'yoda-site-components/lib/actions/AccountAction';
import * as MiniPDPActions from 'yoda-site-components/lib/actions/MiniPDPAction';
import * as actions from '../../../actions/MyListAction';
import * as savedListActions from '../../../actions/SavedListActions';
import ListLandingPage from './ListLandingPage';
import selectListingRedesign from '../../../selectors/ListingRedesignSelector';

function mapStateToProps(state) {
    return {
        deviceType: state.context.deviceType,
        myListsDetails: state.MyList,
        shareList: state.savedList.shareList,
        savedList: state.savedList.savedList,
        error: get(state.savedList, 'savedList.error'),
        addToCart: state.addToCartSite,
        deleteList: state.savedList.deleteList,
        toggleMostWanted: state.savedList.toggleMostWanted || {},
        featureFlags: state.context.featureFlags,
        messagesTexts: state.context.messagesTexts,
        preferences: state.context.preferences,
        headers: state.context.headers,
        mountOnServer: true,
        draftOrder: state.addToCartInterstitialDetails,
        accounts: state.context.accounts,
        authenticationSuccess:
            state.signInSliderDetails && state.signInSliderDetails.authenticationSuccess,
        updatedItem: state.miniPDP && state.miniPDP.updatedItem,
        userState: get(state.accounts, 'userProfile.userState', '0'),
        firstName: get(state.accounts, 'userProfile.firstName', '0'),
        isOOSListingEnabled: selectListingRedesign(state),
        myAlertsProps: state.myAlerts,
        MTLSavedLists: get(state, 'MTLSavedLists', {}),
        lastRemovedListItem: state.lastRemovedListItem,
    };
}

const mapDispatchToProps = (dispatch) => ({
    actions: bindActionCreators(actions, dispatch),
    savedListActions: bindActionCreators(savedListActions, dispatch),
    siteAccountAction: bindActionCreators(siteAccountAction, dispatch),
    LoaderAction: bindActionCreators(LoaderAction.default, dispatch),
    addToCartActions: bindActionCreators(addToCartActions.default, dispatch),
    MiniPDPActions: bindActionCreators(MiniPDPActions, dispatch),
});

export default connect(mapStateToProps, mapDispatchToProps)(ListLandingPage);
